import 'style-loader!./like-condition.css';
import $ from 'jquery';
import h from 'hyperscript';
import searchIcon from 'cadenza/icons/search.svg';
import plusIcon from './plus.svg';
import icon from 'cadenza/utils/icon';
import { default as i18n, defineNamespace } from 'cadenza/utils/i18n';
import LikeConditionDropdown from './like-condition-dropdown';
import messages from './messages_de.properties';
import { default as LikeConditionApi } from 'cadenza/api-client/conditions/condition';
import ConditionElement from '../condition-element';
import { isPositionWithin } from 'cadenza/utils/dom';

defineNamespace('like-condition', messages);

class LikeCondition extends ConditionElement {

  connectedCallback () {
    const input = h('input', {type: 'text'});

    this._addLikeExpressionBtn = h('button.button-icon.add-like-expression', {
      type: 'button'
    }, icon(plusIcon));

    this._dropdownTrigger = h('button.button.button-icon.button-small', {
      type: 'button',
      title: i18n('like-condition:dialog-trigger.title'),
      onclick: event => {
        event.preventDefault();
        event.stopPropagation();
        this._showDropdown();
      }
    }, icon(searchIcon));

    input.disabled = this._dropdownTrigger.disabled = !this.enabled;
    this.append(input, this._dropdownTrigger, this._addLikeExpressionBtn);

    this.conditionApi = new LikeConditionApi(this.selectorId, this.conditionName);

    this._select2Input = initSelect2(input, this._activateCondition.bind(this), this.maxSelection);

    this._createTagsOnClickOk();

    const data = this.previousElementSibling.value;
    this.filterType = data.filterType;
    this.likeExpressions = data.likeExpressions;
  }

  get likeExpressions () {
    const ret = this._select2Input.select2('val');
    return ret instanceof Array ? ret : [];
  }

  set likeExpressions (likeExpressions) {
    return this._select2Input.select2('val', likeExpressions);
  }

  get filterType () {
    return this._filterType;
  }

  set filterType (filterType) {
    this._filterType = filterType;
  }

  _showDropdown () {
    const likeConditionDropdown = new LikeConditionDropdown({filterType: this.filterType});
    likeConditionDropdown.addEventListener('close', () => {
      this.filterType = likeConditionDropdown.returnValue;
      likeConditionDropdown.remove();
      if (this.likeExpressions.length) {
        this._activateCondition();
      }
    });
    document.body.appendChild(likeConditionDropdown);
    likeConditionDropdown.showModal(this._dropdownTrigger);
  }

  _activateCondition () {
    this.conditionApi.setValue({
      filterType: this.filterType,
      likeExpressions: this.likeExpressions
    }).then(() => super.activateCondition());
  }

  _createTagsOnClickOk () {
    // While we're typing, there is a drop mask covering the whole screen, when clicking on it, the input is cleared. Hence the hack below
    const select2InputElem = this.querySelector('input.select2-input');
    const select2DropMask = document.querySelector('.select2-drop-mask');

    document.addEventListener('mousedown', (event) => {
      if (event.target === select2DropMask && select2InputElem.value && isPositionWithin(event.clientX, event.clientY, this._addLikeExpressionBtn)) {
        const currentLikeExpressions = this.likeExpressions;
        currentLikeExpressions.push(select2InputElem.value);
        this.likeExpressions = currentLikeExpressions;
        this._select2Input.trigger('change');
      }
    }, true);
  }

}

function initSelect2 (input, onChange, maxSelection) {
  return $(input).select2({
    tags: [],
    placeholder: i18n('like-condition:select2.placeholder'),
    dropdownCssClass: 'like-condition-select2-dropdown',
    formatSelectionTooBig: limit => i18n('like-condition:select2.selectionTooBig', {count: limit}),
    maximumSelectionSize: maxSelection
  }).on('change', onChange);
}

customElements.define('d-like-condition', LikeCondition);
